import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {LinkComponent} from "./link.component";


const routes: Routes = [
  {
    path: 'link',
    component: LinkComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class LinkRoutingModule {
}
